<template>
    <div id="popupNotice" hidden="" class="popup-wrap is-visible" data-index="1" aria-hidden="true">
        <div role="dialog" aria-labelledby="popupNoticeTitle" class="popup popup-type1" tabindex="0">
            <!-- 팝업 내용 -->
            <div class="blind-area popup-focus dv-ios-only" role="text" aria-label=""></div>
            <div class="popup-container">
                <div class="popup-header">
                    <h3 class="tit-h3">{{ $t('sdp.inquiry.message.pop_text.covid19.member.title') }}</h3>
                </div>
                <div class="popup-body popup-scroll">
                    <div class="para-wrap">
                        <p class="para" v-html="$t('sdp.inpuiry.message.pop_text.covid19.member')"></p>
                    </div>
                </div>
                <div class="popup-footer">
                    <div class="btn-wrap">
                        <button type="button" @click="closeNotice()" class="btn btn-type2 popup-close btn-primary" aria-controls="popupNotice" :title="$t('gwa.alt.inquiry.wa_title_4')"><span>{{ $t('sdp.inquiry.message.pop_text.covid19.member.ok') }}</span></button>
                    </div>
                </div>
                <button type="button" @click="closeNotice()" class="btn-ico btn-popup-close popup-close" aria-controls="popupNotice" :title="$t('gwa.alt.inquiry.wa_title_4')"><span><i class="ico ico-close2">{{ $t('gwa.alt.common.wa_label_19') }}</i></span></button>
            </div>
            <!-- 팝업 내용 -->
        </div>
    </div>
</template>

<script>
    import qs from "qs";

    export default {
        name: "InquiryMemberNoticePop",
        data() {
            return {
                cntryCode: _domainCntryCode
            }
        },
        created() {
        },
        watch: {
        },
        computed: {
        },
        methods: {
            track () {
                console.log('@@@@ track:', this.$router.currentRoute.path);
                this.$ga.page(this.$router.currentRoute.path)
            },
            closeNotice() {
                console.log('closeDimmer');
                ui.popup.close("popupNotice");
                dimmer.close('dimmer-popup', 0.6);
            }
        },
        mounted() {
            document.body.addEventListener('keyup', e => {
                if (e.keyCode === 27) {
                    dimmer.close('dimmer-popup', 0.6);
                    // 이전 페이지 이동
                    const r = { path : `/main`};
                    this.$router.push(r);
                }
            });
        }
    }
</script>

<style scoped>

</style>